import { message as antdMessage } from 'antd'

/**
 * Системийн нэгдсэн toast. Өмнө нь `notification.open`-оор хаах товчгүй,
 * алдааных нь хэзээ ч автоматаар хаагддаггүй (duration: 0) toast гаргадаг
 * байсан тул хэрэглэгч гараар дарж хаах шаардлагатай болдог байв.
 * Одоо бусад хуудастай ижил antd `message` ашиглана.
 */
const DEFAULT_DURATION = 5

const message = (messageText, success = false, config = {}) => {
	const { duration = DEFAULT_DURATION, ...rest } = config
	antdMessage.open({
		type: success ? 'success' : 'error',
		content: messageText,
		duration,
		...rest
	})
}

export default message
